import Inputmask from 'inputmask';
import MaskType from './MaskType';

export default {
	[MaskType.DATE]: {
		inputMask: new Inputmask('datetime', {
			inputFormat: 'mm/dd/yyyy',
			placeholder: "MM/DD/YYYY",
			clearMaskOnLostFocus: false,
		}),
		validation: {
			validationRegExp: /^\d{2}\/\d{2}\/\d{4}$/,
			validationErrorMessage: data => `${data} does not match MM/DD/YYYY`,
		},
		className: "mask-date"
	},
	[MaskType.DECIMAL]: {
		inputMask: new Inputmask('decimal', {
			placeholder: '0.00',
			digits: 2,
			digitsOptional: false,
			allowMinus: true,
			clearMaskOnLostFocus: false,
			rightAlign: false,
			positionCaretOnClick: 'none',
			numericInput: false
		}),
		validation: {
			validationRegExp: /^-?\d+\.\d{2}$/,
			validationErrorMessage: data => `${data} is not a decimal number`
		},
		className: "mask-decimal"
	},
	[MaskType.DECIMAL_POSITIVE]: {
		inputMask: new Inputmask('decimal', {
			placeholder: '0.00',
			digits: 2,
			digitsOptional: false,
			allowMinus: false,
			clearMaskOnLostFocus: false,
			rightAlign: false,
			positionCaretOnClick: 'none',
			numericInput: false
		}),
		validation: {
			validationRegExp: /^\d+\.\d{2}$/,
			validationErrorMessage: data => `${data} is not a decimal number`
		},
		className: "mask-decimal-positive"
	},
	[MaskType.EMAIL]: {
		inputMask: new Inputmask({
			alias: "email",
			jitMasking: true,
		}),
		validation: {
			validationRegExp: /^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/,
			validationErrorMessage: () => "Invalid email"
		},
		className: "mask-email"
	},
	[MaskType.INTEGER]: {
		inputMask: new Inputmask('integer', {
			clearMaskOnLostFocus: false,
			rightAlign: false,
			numericInput: false
		}),
		validation: {
			validationRegExp: /^-?\d+$/,
			validationErrorMessage: data => `${data} is not a integer number`
		},
		className: "mask-integer"
	},
	[MaskType.INTEGER_POSITIVE]: {
		inputMask: new Inputmask('integer', {
			clearMaskOnLostFocus: false,
			allowMinus: false,
			rightAlign: false,
			numericInput: false
		}),
		validation: {
			validationRegExp: /^\d+$/,
			validationErrorMessage: data => `${data} is not a integer number`
		},
		className: "mask-integer-positive"
	},
	[MaskType.PHONE]: {
		inputMask: new Inputmask('999-999-9999', {
			placeholder: '   -   -    ',
			clearMaskOnLostFocus: false,
		}),
		validation: {
			validationRegExp: /^\d{3}-\d{3}-\d{4}$/,
			validationErrorMessage: data => `${data} is not a valid phone number: XXX-XXX-XXXX`
		},
		className: "mask-phone"
	},
	[MaskType.ZIPCODE]: {
		inputMask: new Inputmask('99999', {
			placeholder: '',
			clearMaskOnLostFocus: false,
		}),
		validation: {
			validationRegExp: /^\d{5}$/,
			validationErrorMessage: () => `Invalid ZIP Code`
		},
		className: "mask-zip-code"
	},
};

